// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Vesl","header":"MessagesList_header__1MnMh","chat":"MessagesList_chat__1Tzru"};